import api from '../../services/api';

const RECURSO = '/atendimentos/linha-cuidado/perfil/';

class PerfilLinhaCuidadoService {
    obter(atendimentoId = null) {
        const params = {};

        if (atendimentoId) {
            params.atendimento_id = atendimentoId;
        }

        return api.get(RECURSO, { params });
    }
}

const perfilLinhaCuidadoService = new PerfilLinhaCuidadoService();

export default perfilLinhaCuidadoService;
